var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/meiya_c.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [
                    _vm._v("\n\t\t\t\t\t美亚1-6类团意险（C款）\n\t\t\t\t\t"),
                  ]),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v("1-6类职业 | 最高可保100万 | 5-6类可保高空"),
                  ]),
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t① 线上投保，支持月单\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t② 可扩展自费药\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t③ 3人起保，最高可保100万\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t④ 意外医疗保额为单次事故限额，无次数限制，多次事故之间无间隔期\n\t\t\t\t\t"
                    ),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t下载美亚团意险职业类别表\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _vm._v("\n\t\t\t\t\t\t保障期限：\n\t\t\t\t\t\t"),
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择保障期限" },
                              on: { change: _vm.computePrice },
                              model: {
                                value: _vm.qixian,
                                callback: function ($$v) {
                                  _vm.qixian = $$v
                                },
                                expression: "qixian",
                              },
                            },
                            _vm._l(_vm.qixians, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t扩展自费药方案：\n\t\t\t\t\t\t"
                          ),
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择扩展方案" },
                              on: { change: _vm.onChangeKuozhanRate },
                              model: {
                                value: _vm.kuozhanRate,
                                callback: function ($$v) {
                                  _vm.kuozhanRate = $$v
                                },
                                expression: "kuozhanRate",
                              },
                            },
                            _vm._l(_vm.kuozhanRateList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                      "table-loading": _vm.isShowLoading,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "30px" } },
                [
                  _c("avue-crud", {
                    attrs: {
                      data: _vm.questionData,
                      option: _vm.questionOption,
                      "span-method": _vm.onQuestionSpanMethod,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa, index) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "20px",
                                      "background-color": "MediumSeaGreen",
                                      color: "white",
                                      padding: "4px",
                                      "border-radius": "4px",
                                      "margin-right": "8px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                                qa.question ===
                                "投保人名称含有哪些关键字不能投保本保险？"
                                  ? [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t如投保人名称中包含：\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t危险品、人力资源、拆、分包、外包、劳务派遣、幕墙、脚手架、爆破、爆炸、渔业、隧道\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t，则不能投保本保险。\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  : _vm._e(),
                                qa.question ===
                                "投保本保险有哪些系统校验需要特别注意？"
                                  ? [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t除了\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t投保人信息真实性校验、最低投保人数校验、被保险人年龄校验、被保险人投保份数校验\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t等常规校验需要注意之外，以下几个特殊校验也需要重点关注。\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t《投保重要事项确认书》盖章件模板是否使用正确、是否清晰完整、是否正向上传、印章企业名称是否与投保人名称一致；切勿伪造印章投保！！！\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t投保界面录入的经办人/联系人是否存在于\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("不同投保人的有效保单下；")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("投保人的所有有效保单")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t是否存在\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("超过三个经办人/联系人")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t的情况; 如因系统校验核保未通过，请关注报错提示，进行相应调整后再次投保即可。\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  : qa.question ===
                                    "被保险人出险时的职业类别高于投保时的职业类别，理赔会打折赔付吗？"
                                  ? [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t如被保险人的实际职业类别高于所申请参保保险计划对应的职业类别，则发生理赔时该被保险人的实际赔付金额按以下公式计算：\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t实际赔付金额=符合保险合同约定的赔付金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%。\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  : qa.question ===
                                    "意外医疗的最长给付时间是多久？保单到期后还能保障多久？"
                                  ? [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t按照条款约定，若被保险人因遭遇意外事故而\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "于意外事故发生日起一百八十天内"
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t寻求合法注册的医生、护士、医院或救护车服务，则对其因此已支出的必需且合理的实际医药费用，保险公司按保险合同约定补偿该被保险人。\n\t\t\t\t\t\t\t\t\t即使保险合同到期，只要是属于\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("意外事故发生日起一百八十天内")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t支出的必需且合理的实际医药费用，保险公司也会按保险合同约定补偿该被保险人。\n\t\t\t\t\t\t\t\t\t注：意外事故骨折后续的拆取钢板费用不受180天的限制。\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  : qa.question === "起保人数是怎样要求的？"
                                  ? [
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v(
                                          "仅包含1-3类职业3人起保，包含4-6类职业需要5人起保。"
                                        ),
                                      ]),
                                    ]
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-wrap",
                                        },
                                      },
                                      [_vm._v(_vm._s(qa.answer))]
                                    ),
                              ],
                              2
                            ),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "30px",
                          "margin-left": "40px",
                        },
                      },
                      [
                        _c("avue-crud", {
                          attrs: {
                            data: _vm.questionData,
                            option: _vm.questionOption,
                            "span-method": _vm.onQuestionSpanMethod,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c(
                        "p",
                        { staticStyle: { "line-height": "28px" } },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t1、本保险为互联网专属产品，由美亚财产保险有限公司（以下简称“保险公司”）承保，面向全国（不含港澳台）进行销售，本保险支持在线投保、核保、保单查询和报案等服务，您可以通过“美亚保险客户服务”微信小程序线上办理退保、批改和理赔等业务。目前保险公司在上海、北京、广东省（含深圳市）、江苏省和浙江省设有分支机构。\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t保险公司无分支机构的地区，可能无法向您提供及时的面对面线下服务，保险公司将通过电话及互联网通道在线为您提供保单服务。如有任何疑问，可拨打保险公司客户服务热线400-820-8858。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t2、所有的保险责任及条款均以与保险公司正式订立保险合同的规定为准。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t3、被保险人身故保险金受益人为被保险人的继承人。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t4、本保险最早的生效时间为T+1零时，最晚为T+30零时（T是指投保成功日）。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t5、投保人须获得被保险人的同意，方可为其投保本保险。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t6、本保险的约定投保资格须同时满足以下要求：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t（1）属于投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。前述雇员参保时的年龄限制：18-65周岁。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("为明确起见，相关定义约定如下："),
                          ]),
                          _c("br"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t1）本保险所称的投保行业不包括任何提供人力资源服务的人力资源、劳务派遣公司及其他人力资源中介。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t2）本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，且该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期劳动用工的情形。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t3）本保险所称的“在岗全职雇员”须在与投保人存在劳动用工关系期间，不存在除投保人之外的其他用人单位或用工主体。为避免歧义，在岗全职雇员不包括与投保人存在劳动用工关系的非全职临时工、小时工、兼职实习生等非全职雇员以及培训学员、会员等不具备劳动用工关系的人员。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（2）属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t7、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t如投保人名称中包含以下关键字，则保险公司不接受该投保申请：危险品、人力资源、拆、分包、外包、劳务派遣、幕墙、脚手架、爆破、爆炸、渔业、隧道。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t8、保险合同成立时投保人数不低于3人。\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "如被保险人含职业类别四或职业类别五或职业类别六，则被保险人人数应不低于5人。"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t单张保单最高投保人数为1000人。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t9、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t保险公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总赔偿限额为限。如在任一意外事故中，前述总赔偿限额低于按每一被保险人的保险金额给付的总赔偿金额，则保险公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t10、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("每一意外事故总赔偿限额说明："),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t每一意外事故总赔偿限额为以下两者较高者：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（1) 保险合同生效时，保险单所载单个被保险人在意外身故及伤残保障项下所适用的最高保险金额的10倍；\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（2) 人民币500万元。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t11、本保险所承保的被保险人的职业类别以投保时约定的为准（具体职业请以保险公司职业分类表为准）。投保人在为被保险人申请投保时，应按被保险人的实际职业类别填写，如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准。若申报的被保险人的职业类别不真实，则视为投保人故意未依法履行如实告知义务，并按照下列规定处理\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\n\t\t\t\t\t\t（1）\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t如该被保险人的实际职业类别为申请投保时本合同约定不接受投保的职业类别，则其被保资格将被取消；对于取消其被保资格前所发生的保险事故，保险公司不承担任何保险责任。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t除本合同另有约定外，保险公司在前述取消该被保险人被保资格的情形下将退还其项下相应的未满期保险费。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（2）如该被保险人的实际职业类别为申请投保时本合同约定接受投保的职业类别，但高于为其所申报保险计划对应的职业类别，则该被保险人发生保险事故后，无论该保险事故是否与职业类别相关，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t12、如任何被保险人在保险期间内职业类别发生任何变更，投保人或该被保险人应于变更后十个工作日内书面通知保险公司。保险公司收到投保人或该被保险人的通知后，有权按下列规定调整该被保险人的承保条件或拒绝接受该被保险人继续成为本合同的被保险人：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（1）如其变更后的职业类别相比变更前风险程度降低的，则保险公司按日比例退还自其变更职业类别之日起相应保险费的差额；\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别的，投保人应按日比例补缴自该被保险人变更职业类别之日起相应保险费的差额；\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（3）如其变更后的职业类别为本合同约定不接受投保的职业类别，则自该被保险人变更职业类别之日起，保险公司不再接受该被保险人继续成为本合同的被保险人，其被保资格将于变更职业类别之日二十四时丧失，保险公司将按承保日比例退还该被保险人未满期保险费。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t投保人或被保险人未履行上述通知义务的，保险公司按照下列规定进行处理：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（1）如其变更后的职业类别为本合同约定不接受投保的职业类别，则其被保资格于变更职业类别之日二十四时丧失，对于其丧失被保资格后所发生的保险事故，保险公司不承担任何保险责任；\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别，则对于该被保险人在职业类别变更后发生的保险事故，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/变更后职业类别对应的应交保险费）*70%\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t13、每位团体成员于保险公司投保的团体意外伤害保险仅限一份，多投无效，不同计划重叠购买的无效。若任一团体成员于保险公司投保多份团体意外伤害保险或购买多份计划，则保险公司仅以首次成功投保的计划为准，并退还其它保险计划项下已收取的保险费。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t14、同一职业类别的被保险人必须选择相同的保险计划。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t15、本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t若5类和6类的被保险人在从事5米及以上高处作业时未系绑安全带，则保险公司不承担任何保险责任。对于职业类别为1类至4类的被保险人，本保险不承保其任何5米及以上的高处作业。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t16、被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，保险公司不承担任何保险责任。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t17、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("意外医药补偿保额说明："),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（1）若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（2）若任何被保险人拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额的105%为限，但须扣除该被保险人任何已取得的医药费用补偿。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t18、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t19、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上（含二级）公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t20、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t《美亚附加意外每日住院津贴团体收入保障保险》项下所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t21、本保险为团体保险，投保人不得以任何方式销售给第三方（第三方包括但不限于被保险人本人）。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t22、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t若保险公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t23、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t24、被保险人的投保年龄以申请时被保险人的周岁年龄为准。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t25、新增或减少被保险人的申报：保险合同有效期间，若有团体成员的新增或减少，投保人须将该新增及减少的成员资料申报至保险公司。对于新增团体成员，经保险公司确认同意承保后，该新增成员自投保人申报次日零时起获得被保资格。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t26、保险凭证：保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t27、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t投保人未能披露与本保险相关之重大事实（包括但不限于是否符合本投保申请上述所有投保前提条件，下同）可能导致保险公司不承担保险责任。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t重大事实系指可能影响保险公司风险评估或接受投保申请与否之事实。如果投保人不能确定某些事实是否属于应披露之重大事实，请予以披露。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t28、本保险\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("仅提供电子版本的保险单"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t，根据预留的电子邮件地址发送电子版本的保险单，投保人可登录\n\t\t\t\t\t\t"
                          ),
                          _c(
                            "el-link",
                            {
                              attrs: {
                                href: "https://www-401.aiginsurance.com.cn/CIRC/accident_policy_enquiry.asp",
                                type: "primary",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t美亚保险信息自主查询系统\n\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                          _vm._v("\n\t\t\t\t\t\t进行保单验真。\n\t\t\t\t\t\t"),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t29、本保险适用条款：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t（1）\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("通用条款："),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t《美亚附加被保险人资格条款（2022年第一版）》《美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）》《美亚附加被保险人职业类别处理规则条款（2022年第一版）》《美亚附加不承保特定医院条款（2022年第一版）》《美亚附加短期保险费条款（2022年第一版）》《美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）》《美亚附加经济制裁责任免除条款》《美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）》《美亚附加特种作业限制条款（2021年第二版）（互联网专属）》《美亚团体意外伤害保险（2021年第一版）（互联网专属）》《美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）》《美亚附加争议处理条款（2023年第一版）》\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t（2）\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("意外医药补偿保障适用条款："),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t如投保的意外医药补偿保障仅限医保范围内的医疗费用，不承保全额自费费用，则适用《美亚附加意外医药补偿团体医疗保险（2022年第三版）（互联网专属）》；\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t如投保的意外医药补偿保障不限医保范围内的医疗费用，保障全额自费费用，则适用《美亚附加意外医药补偿团体医疗保险（2021年第三版）（互联网专属）》\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v("\n\t\t\t\t\t\t30、\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("重要提示："),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（1）请仔细阅读本保险所有投保前提条件，确认符合所列投保前提条件方可进行投保。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（2）为了保障您自身的权益，请在确认投保本保险前，仔细阅读理解保险合同（包括但不限于保险条款等）的各项规定，\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("尤其是免除保险人责任的规定"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t。如有疑问，请致电：4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（3）本投保申请、保险条款、保险单、批单或批注（如有）及其它约定书均为保险合同的构成部分。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（4）为了维护您的利益，投保人/被保险人需详细并如实填写投保申请上所列资料。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t（5）美亚财产保险有限公司综合偿付能力充足率达到监管要求，且风险综合评级提示操作、战略、声誉和流动风险较小，具体偿付能力指标和风险综合评级结果请查询公司官方网站\n\t\t\t\t\t\t"
                          ),
                          _c(
                            "el-link",
                            {
                              attrs: {
                                href: "www.aig.com.cn",
                                type: "primary",
                              },
                            },
                            [_vm._v("www.aig.com.cn")]
                          ),
                          _vm._v("\n\t\t\t\t\t\t。\n\t\t\t\t\t\t"),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t保险合同项下应付保险费含适用的增值税。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                        ],
                        1
                      ),
                      _c("el-divider"),
                      _c("h3", [_vm._v("重要提示")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t1、投保人须获得被保险人的同意，方可为其投保本保险。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t2、本保险为团体保险，投保人不得以任何方式销售给第三方(第三方包括但不限于被保险人本人)。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t3、保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t4、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t任何已提出投保申请的人员或在保险期间内可能提出参保申请的人员，均须符合本保险约定的投保资格。如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t5、本保险所承保的被保险人的职业类别以投保时约定的为准（具体职业请以保险公司职业分类表为准）。投保人在为被保险人申请投保时，应按被保险人的实际职业类别填写，如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准。若\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t申报的被保险人的职业类别不真实，则视为投保人故意未依法履行如实告知义务，并按照下列规定处理：\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t(1)\n\t\t\t\t\t\t\t如该被保险人的实际职业类别为申请投保时本合同约定不接受投保的职业类别，则其被保资格将被取消；对于取消其被保资格前所发生的保险事故，保险公司不承担任何保险责任。除本合同另有约定外，保险公司在前述取消该被保险人被保资格的情形下将退还其项下相应的未满期保险费。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t(2)\n\t\t\t\t\t\t\t如该被保险人的实际职业类别为申请投保时本合同约定接受投保的职业类别，但高于为其所申报保险计划对应的职业类别，则该被保险人发生保险事故后，无论该保险事故是否与职业类别相关，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t6、如任何被保险人在保险期间内职业类别发生任何变更，投保人或该被保险人应于变更后十个工作日内书面通知保险公司。保险公司收到投保人或该被保险人的通知后，有权按下列规定调整该被保险人的承保条件或拒绝接受该被保险人继续成为本合同的被保险人：\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t（1）如其变更后的职业类别相比变更前风险程度降低的，则保险公司按日比例退还自其变更职业类别之日起相应保险费的差额；\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别的，投保人应按日比例补缴自该被保险人变更职业类别之日起相应保险费的差额；\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t（3）如其变更后的职业类别为本合同约定不接受投保的职业类别，则自该被保险人变更职业类别之日起，保险公司不再接受该被保险人继续成为本合同的被保险人，其被保资格将于变更职业类别之日二十四时丧失，保险公司将按承保日比例退还该被保险人未满期保险费。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t投保人或被保险人未履行上述通知义务的，保险公司按照下列规定进行处理：\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（1）如其变更后的职业类别为本合同约定不接受投保的职业类别，则其被保资格于变更职业类别之日二十四时丧失，对于其丧失被保资格后所发生的保险事故，保险公司不承担任何保险责任；\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别，则对于该被保险人在职业类别变更后发生的保险事故，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/变更后职业类别对应的应交保险费）*70%。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t7、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "被保险人的身故保险金受益人为被保险人的继承人。"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t8、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总暗偿限额为限。如在任一意外事故中，前述总赔偿限额低干按每一被保险人的保险金额给付的总赔偿金额，则本公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t9、若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则本公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t若任何被保险人\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t则本公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t保险金额的百分之一百零五(105%)为限，但须扣除该被保险人任何已取得的医药费用补偿。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t10、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T\n\t\t\t\t\t\t\t3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。若5类和6类的被保险人在从事5米及以上高处作业时未系绑安全带，则保险公司不承担任何保险责任。对于职业类别为1类至4类的被保险人，本保险不承保其任何5米及以上的高处作业。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t11、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。特种作业证书以国家(特种作业人员安全技术培训考核管理规定》规定的为准。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t12、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t13、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上(含二级)公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t14、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t《美亚附加意外每日住院津贴团体收入保障保险》项下所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t15、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t16、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t若本保险公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致本保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则本保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t17、本保险单与投保申请、保险条款、批单或批注（如有）及其它约定书均为保险合同的构成部分。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t18、为了保障您自身的权益，请在确认投保本保险前，仔细阅读理解保险合同（包括但不限于保险条款等）的各项规定，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("尤其是免除保险人责任的规定"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t。如有疑问，请致电：4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t19、为了保障您的利益，请在收到本保险单一周内拨打我公司服务热线4008208858核实保险单资料，包括保险单所列示的销售人员或销售中介机构信息。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t20、保险合同项下应付保险费含适用的增值税。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "下载", name: "3" } },
            [
              _c("avue-crud", {
                ref: "crud_content",
                attrs: { data: _vm.listDatas, option: _vm.option },
                scopedSlots: _vm._u([
                  {
                    key: "menu",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-download", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onDownload(row)
                              },
                            },
                          },
                          [_vm._v("下载")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }